import { compiler } from "markdown-to-jsx";

export const Legacy_CompileMarkdown = (content: string) => {
  return compiler(content.trim() + '\n\n', {
    forceWrapper: true,
    wrapper: 'div',
    overrides: {
      span: 'p',
    },
    disableParsingRawHTML: true
  });
};

export const CompileMarkdown = (content: string) => {
  return compiler(content.trim(), {
    forceBlock: true
  })
};



export const CompileHeadingToSpan = (content: string) => {
  const lines = content.split(/\r?\n/);
  const transformed = lines.map(line => {
    const trimmed = line.trim();
    const match = trimmed.match(/^(#{1,6})\s+(.*)$/);

    if (match) {
      const level = match[1].length;
      const text = match[2];

      if (text) {
        return `<span class=\"attrax-heading attrax-heading--h${level}\">${text}</span>`;
      }
      return '';
    }

    if (trimmed) {
      return `<span class=\"attrax-heading\">${trimmed}</span>`;
    }
    return '';
  }).filter(Boolean).join(' ');

  if (!transformed) {
      return null;
    }

  return compiler(transformed, { disableParsingRawHTML: false });
};

